import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

import {
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { Button } from 'app-core';
import { DoctorsDummyDataService } from 'app-service';
import { Subject, takeUntil } from 'rxjs';

import ButtonType = Data.Core.ButtonType;

@Component({
  selector: 'app-dummy-data-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DoctorsDummyDataService],
})
export class DummyDataCouponsComponent {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public doctorIDControl = new FormControl('', Validators.required);
  public couponsForm!: FormGroup;
  public couponsCount: number = 0;
  public createCouponsButton: Button = new Button({
    label: 'Create Coupons',
    type: ButtonType.button,
    action: () =>
      this.createDummyCoupons(this.doctorIDControl.value!.toString()),
    disabled: () => !this.couponsForm!.valid,
  });
  public getCouponsButton: Button = new Button({
    label: 'Get Coupons Count',
    type: ButtonType.button,
    action: () =>
      this.getDummyCouponsCount(this.doctorIDControl.value!.toString()),
    disabled: () => !this.couponsForm!.valid,
  });

  public constructor(
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _formBuilder: FormBuilder,
    private readonly _doctorsDummyDataService: DoctorsDummyDataService,
  ) {
    this.couponsForm = this._formBuilder.group([this.doctorIDControl]);
  }

  private createDummyCoupons(contactNumber: string): void {
    this._doctorsDummyDataService
      .createDoctorsCoupons(contactNumber)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => {},
        () => {},
        () => {
          this.getDummyCouponsCount(contactNumber);
        },
      );
  }

  private getDummyCouponsCount(contactNumber: string): void {
    this._doctorsDummyDataService
      .getDummyDoctorsCouponCount(contactNumber)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((count: any) => {
        this.couponsCount = count.count;
        this._cdRef.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
